import { type DomainAccessControlConfig } from 'domains/shifts/utils/domain/accessControl'
import { PickupRouteAccessControl } from 'gin-and-tonic/containers/nav/utils/pickupRouteAccessControl'

export const shiftsAccessControl: DomainAccessControlConfig = {
  ...(PickupRouteAccessControl as DomainAccessControlConfig),
}
